import React, { useState } from 'react';
import { Alert, Button, Space } from 'antd';
import { paymentError, paymentErrorMessage } from '../../utilities/paymentErrors';
import { money } from '../../utilities/paymentPresentation';
import { blockerLabel } from '../../utilities/blockerLabels';
import { PaymentsV2Workspace } from '../query-workspace/PaymentsWorkspace';
export default function LifecycleBlockers({ error, queryPk, queryId, capabilities = {}, onRevise }) {
  const [paymentsOpen, setPaymentsOpen] = useState(false);
  if (!error) return null;
  const parsed = paymentError(error);
  const blocked = parsed.code === 'QUERY_LIFECYCLE_BLOCKED';
  const blockers = parsed.data?.blockers || [];
  return <><Alert type="error" message={blocked ? "Can't do this yet" : paymentErrorMessage(error)} description={blocked && <>
    <ul>{blockers.map((row, index) => <li key={`${row.kind}-${row.id}-${index}`}>{blockerLabel(row)}{row.amount != null && ` · ${money(row.amount)}`}</li>)}</ul>
    <div>{parsed.message}</div><Space wrap><Button onClick={() => setPaymentsOpen(true)}>Open Payments</Button>
      {blockers.some(row => row.kind === 'invoice_locked') && <>
        {capabilities.can_revise_price?.allowed && onRevise && <Button onClick={onRevise}>Revise price</Button>}
        {capabilities.can_unlock_invoice?.allowed && <Button onClick={() => setPaymentsOpen(true)}>Unlock in Payments</Button>}
      </>}
    </Space></>} />
    {paymentsOpen && <PaymentsV2Workspace open queryPk={queryPk} queryId={queryId} onClose={() => setPaymentsOpen(false)} />}
  </>;
}
